var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Arr from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import { flow, pipe } from 'fp-ts/function';
import { Fixtuur } from '@fixtuur/backpack';
var isImage = function (d) { return d.kind === 'image'; };
var isSwatch = function (d) { return d.kind === 'swatch'; };
var displayName = function (v) {
    return v === null ? 'furniture.option.none' : Fixtuur.Configuration.Option.valueString(v);
};
var propertyValueDisplay = function (v) {
    if (!v || (v.displayImage === undefined && v.displayColour === undefined)) {
        return O.none;
    }
    else if (v.displayImage) {
        return O.some({ kind: 'image', url: v.displayImage });
    }
    else {
        return O.some({ kind: 'swatch', value: v.displayColour });
    }
};
/**
 * construct a Property Option based on the Fixtuur Option Value, using the Name and Configurable Properties
 *  to fetch any display information we hold for the Option (i.e. images or swatch colours)
 */
export var fromFixtuur = function (configurableProperties, name, value, selected, incompatible) {
    if (selected === void 0) { selected = false; }
    if (incompatible === void 0) { incompatible = false; }
    return pipe(Fixtuur.Configuration.ConfigurableProperties.property(name, configurableProperties), O.chain(function (prop) {
        var v = prop.propertyValues[Fixtuur.Configuration.Option.valueString(value)];
        return propertyValueDisplay(v);
    }), 
    // Selected options should always be compatible
    O.match(function () { return ({
        id: value,
        displayName: displayName(value),
        status: selected ? 'active' : 'inactive',
        compatible: !incompatible || selected,
    }); }, function (display) { return ({
        id: value,
        displayName: displayName(value),
        status: selected ? 'active' : 'inactive',
        compatible: !incompatible || selected,
        display: display,
    }); }));
};
export var fromFixtuurPropertyValues = function (selectedProductId, propertyName, propertyValues, inspoProduct) {
    return pipe(Object.entries(propertyValues), Arr.map(function (_a) {
        var name = _a[0], value = _a[1];
        var option = {
            id: name,
            displayName: value.displayText,
            status: Fixtuur.InspirationProduct.isPropertyCurrentlySelected(selectedProductId, propertyName, value, inspoProduct)
                ? 'active'
                : 'inactive',
            compatible: Fixtuur.InspirationProduct.isPropertyCompatible(selectedProductId, propertyName, value, inspoProduct),
        };
        return pipe(propertyValueDisplay(value), O.match(function () { return option; }, function (display) {
            return __assign(__assign({}, option), { display: display });
        }));
    }));
};
export var display = function (o) { return pipe(o.display, O.fromNullable); };
export var swatch = flow(display, O.filter(isSwatch));
export var image = flow(display, O.filter(isImage));
export var swatchValue = function (o) {
    return pipe(o, swatch, O.map(function (d) { return d.value; }), O.toUndefined);
};
export var imageValue = function (o) {
    return pipe(o, image, O.map(function (d) { return d.url; }), O.toUndefined);
};
